import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'forCustomization'
})
export class ForCustomizationPipe implements PipeTransform {
	transform(_targetPropertyMap: string): boolean {
		return _targetPropertyMap === 'unrestrictedProperties';
	}

}
